import React, { Component } from 'react';
import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import PropTypes from 'prop-types';
import { sendJoinReason } from './action';
import { Modal } from 'react-bootstrap';
import './style.scss';
import { closeRequestEventReasonPopUp } from './action';
import RequestEventForm from './RequestEventForm';
import _ from 'lodash';
class RequestEventRessonPopUp extends Component {

  constructor(props) {
    super(props);
    this.requestJoinEvent = this.requestJoinEvent.bind(this);
    this.resetPopUp = this.resetPopUp.bind(this);
    this.state = {
      counter: 0,
      content: ''
    };
  }

  requestJoinEvent(data) {

    const values = data.toJS ? data.toJS() : data;

    const { eventInfo } = this.props;
    const eventId = _.get(eventInfo, 'objectId', '');
    const presidentId = _.get(eventInfo, 'createdBy.objectId', '');
    let { reason = '', reasonEx = '', reasonExInput = '' } = values;

    if (reasonEx === 'その他（自由記入）') {
      reasonEx = reasonExInput;
    }

    this.props.sendJoinReason({ eventId, reason, reasonEx, presidentId });
  }

  resetPopUp() {
    this.setState({
      counter: 0,
      content: ''
    });
  }

  render() {
    const { eventInfo } = this.props;
    const eventId = _.get(eventInfo, 'objectId', '');
    let initialValues = {};

    if (localStorage.getItem('reasonStorage')) {
      const reasonStorage = JSON.parse(localStorage.getItem('reasonStorage'));
      initialValues = _.find(reasonStorage, {'eventId': eventId}) || {};
    }

    return (
      <Modal
        backdrop={true}
        keyboard={false}
        show={this.props.show}
        onShow={this.resetPopUp}
        onHide={this.props.closeRequestEventReasonPopUp}
        id="request-join-event-modal"
      >
        <Modal.Body>
          <RequestEventForm initialValues={initialValues} eventId={eventId} onSubmit={this.requestJoinEvent} />
        </Modal.Body>
      </Modal>

    );
  }
}

RequestEventRessonPopUp.propTypes = {
  sendJoinReason: PropTypes.func,
  eventInfo: PropTypes.object,
  show: PropTypes.bool,
  closeRequestEventReasonPopUp: PropTypes.func
};

const mapStateToProps = state => {
  return {
    eventInfo: state.get('eventDetail').get('eventInfo'),
    show: state.get('requestReason').get('show')
  };
};

const mapDispatchToProps = dispatch => ({
  sendJoinReason: (payload) => dispatch(sendJoinReason(payload)),
  closeRequestEventReasonPopUp: () => dispatch(closeRequestEventReasonPopUp())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withImmutablePropsToJS(RequestEventRessonPopUp));
